<template>
  <v-card tile>
    <v-toolbar class="primary white--text">
      <v-toolbar-title>Update Rate</v-toolbar-title>
      <v-spacer />
      <v-text-field
        style="margin-top: 10px"
        prepend-inner-icon="search"
        solo
        outlined
        clearable
        label="Search Product"
        @keyup.native="keymonitor($event)"
      />
      <v-spacer />
      <v-btn icon dark @click.native="printReport()">
        <v-icon>print</v-icon>
      </v-btn>
      <v-btn icon dark @click.native="close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs3>
          <v-select
            v-model="selectedProductGroup"
            item-text="name"
            return-object
            :items="productGroups"
            clearable
            label="Product Group Filter"
          ></v-select>
        </v-flex>
        <v-flex xs3>
          <v-edit-dialog
            v-if="hasPurchasePermission && selectedProductGroup"
            :return-value.sync="bulkPurchaseRate"
            large
            lazy
            persistent
            @save="saveBulkRate(true)"
            @cancel="cancelRateSave"
            @open="openRateSave"
            @close="closeRateSave"
          >
            <div><h3>Update Purchase Rate</h3></div>
            <template slot="input">
              <div class="mt-3 title">Bulk Update Purchase Rate</div>
            </template>
            <template slot="input">
              <v-text-field
                v-model="bulkPurchaseRate"
                :rules="[onlyNumbers]"
                label="Edit"
                single-line
                counter
                autofocus
                align
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </v-flex>
        <v-flex xs3>
          <v-edit-dialog
            v-if="hasSalePermission && selectedProductGroup"
            :return-value.sync="bulkSellingRate"
            large
            lazy
            persistent
            @save="saveBulkRate(false)"
            @cancel="cancelRateSave"
            @open="openRateSave"
            @close="closeRateSave"
          >
            <div><h3>Update Selling Rate</h3></div>
            <template slot="input">
              <div class="mt-3 title">Bulk Update Selling Rate</div>
            </template>
            <template slot="input">
              <v-text-field
                v-model="bulkSellingRate"
                :rules="[onlyNumbers]"
                label="Edit"
                single-line
                counter
                autofocus
                align
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </v-flex>
        <v-flex xs3>
          <v-edit-dialog
            v-if="selectedProductGroup"
            :return-value.sync="bulkHSN"
            large
            lazy
            persistent
            @save="saveBulkHSN(false)"
            @cancel="cancelRateSave"
            @open="openRateSave"
            @close="closeRateSave"
          >
            <div><h3>Bulk Update HSN code</h3></div>
            <template slot="input">
              <div class="mt-3 title">Bulk Update HSN code</div>
            </template>
            <template slot="input">
              <v-text-field
                v-model="bulkHSN"
                :rules="[onlyNumbers]"
                label="Edit"
                single-line
                counter
                autofocus
                align
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </v-flex>
        <v-flex xs3>
          <v-edit-dialog
            v-if="selectedProductGroup"
            :return-value.sync="bulkSpecialChargePercentage"
            large
            lazy
            persistent
            @save="saveBulkSpecialChargePercentage(false)"
            @cancel="cancelRateSave"
            @open="openRateSave"
            @close="closeRateSave"
          >
            <div><h3>Bulk Update Special Charge</h3></div>
            <template slot="input">
              <div class="mt-3 title">Bulk Update Special Charge</div>
            </template>
            <template slot="input">
              <v-text-field
                v-model="bulkSpecialChargePercentage"
                :rules="[onlyNumbers]"
                label="Edit"
                single-line
                counter
                autofocus
                align
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </v-flex>
      </v-layout>
      <v-data-table :headers="headers" :items="productsByBrand" hide-actions>
        <template slot="items" slot-scope="props">
          <td>
            <h3 class="primary--text">{{ props.item.name }}</h3>
          </td>
          <td class="text-xs-right">
            <v-edit-dialog
              v-if="hasPurchasePermission"
              :return-value.sync="props.item.purchasingPrice"
              large
              lazy
              persistent
              @save="savePurchaseRate(props.item)"
              @cancel="cancelRateSave"
              @open="openRateSave"
              @close="closeRateSave"
            >
              <div>
                <h3>{{ props.item.purchasingPrice }}</h3>
              </div>
              <template slot="input">
                <div class="mt-3 title">Update Purchase Rate</div>
              </template>
              <template slot="input">
                <v-text-field
                  v-model="props.item.purchasingPrice"
                  :rules="[onlyNumbers]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                  align
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-right">
            <v-edit-dialog
              v-if="hasSalePermission"
              :return-value.sync="props.item.sellingPrice"
              large
              lazy
              persistent
              @save="saveSellingRate(props.item)"
              @cancel="cancelRateSave"
              @open="openRateSave"
              @close="closeRateSave"
            >
              <div>
                <h3>{{ props.item.sellingPrice }}</h3>
              </div>
              <template slot="input">
                <div class="mt-3 title">Update Selling Rate</div>
              </template>
              <template slot="input">
                <v-text-field
                  v-model="props.item.sellingPrice"
                  :rules="[onlyNumbers]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                  align
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-right">
            <v-edit-dialog
              :return-value.sync="props.item.HSN_code"
              large
              lazy
              persistent
              @save="saveHSN(props.item)"
              @cancel="cancelRateSave"
              @open="openRateSave"
              @close="closeRateSave"
            >
              <div>
                <h3>{{ props.item.HSN_code }}</h3>
              </div>
              <template slot="input">
                <div class="mt-3 title">Update HSN</div>
              </template>
              <template slot="input">
                <v-text-field
                  v-model="props.item.HSN_code"
                  :rules="[onlyNumbers]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                  align
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-right">
            <v-edit-dialog
              :return-value.sync="props.item.specialChargePercentage"
              large
              lazy
              persistent
              @save="saveSpecialChargePercentage(props.item)"
              @cancel="cancelRateSave"
              @open="openRateSave"
              @close="closeRateSave"
            >
              <div>
                <h3>{{ props.item.specialChargePercentage }}</h3>
              </div>
              <template slot="input">
                <div class="mt-3 title">Update Special Charge</div>
              </template>
              <template slot="input">
                <v-text-field
                  v-model="props.item.specialChargePercentage"
                  :rules="[onlyNumbers]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                  align
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td>
            <h3>{{ props.item.unit }}</h3>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <!-- <v-divider></v-divider> -->
    <!-- <v-card-actions>
            <v-btn @click="setTodayRate">
                Update Rate
            </v-btn>
        </v-card-actions> -->
  </v-card>
  <!--    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">-->
  <!--      {{ snackText }}-->
  <!--      <v-btn flat @click="snack = false">Close</v-btn>-->
  <!--    </v-snackbar>-->
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { ratesReportPDF } from "../../utils/pdf-reports/rates-report";
export default {
  props: ["rateCard", "brand"],
  data() {
    return {
      snack: false,
      search: null,
      snackColor: "",
      snackText: "",
      bulkPurchaseRate: 0,
      bulkSellingRate: 0,
      bulkHSN: null,
      bulkSpecialChargePercentage: null,
      selectedProductGroup: null,
      headers: [
        {
          text: "Product",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "Purchase Rate",
          value: "prate",
          sortable: false,
        },
        {
          text: "Selling Rate",
          value: "srate",
          sortable: false,
        },
        {
          text: "HSN code",
          value: "hsn",
          sortable: false,
        },
        {
          text: "Special Charge",
          value: "specialCharge",
          sortable: false,
        },
        {
          text: "UNIT",
          value: "unit",
          sortable: false,
        },
      ],
      onlyNumbers: (v) => !isNaN(v) || "Should be a valid Number",
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "productGroups",
      this.$root.$firebaseRefs.productGroup
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "roleAndPermission"]),
    productsByBrand() {
      return this.products.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          (!item.unitsDetails || !item.unitsDetails.length) &&
          (this.selectedProductGroup
            ? item["productGroup"] == this.selectedProductGroup[".key"]
            : true) &&
          (!!this.search
            ? !!item["name"].toLowerCase().includes(this.search.toLowerCase())
            : true)
      );
    },
    hasSalePermission() {
      if (
        this.roleAndPermission &&
        this.roleAndPermission.permissions &&
        this.roleAndPermission.permissions.length &&
        this.roleAndPermission.permissions.indexOf("SALE_RATE_VIEW_EDIT") > -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasPurchasePermission() {
      if (
        this.roleAndPermission &&
        this.roleAndPermission.permissions &&
        this.roleAndPermission.permissions.length &&
        this.roleAndPermission.permissions.indexOf("PURCHASE_RATE_VIEW_EDIT") >
          -1
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    printReport() {
      let doc = ratesReportPDF({
        products: this.productsByBrand,
      });
      pdfMake.createPdf(doc).download();
    },
    keymonitor(event) {
      this.search = event.target.value;
    },
    close() {
      this.$emit("close");
    },
    savePurchaseRate(data) {
      if (isNaN(data.purchasingPrice)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          purchasingPrice: data.purchasingPrice,
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveHSN(data) {
      if (isNaN(data.HSN_code)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          HSN_code: data.HSN_code,
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveSpecialChargePercentage(data) {
      if (isNaN(data.specialChargePercentage)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          specialChargePercentage: data.specialChargePercentage,
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveBulkRate(isPurchase) {
      let productsToUpdate = this.productsByBrand;
      if (isPurchase) {
        if (isNaN(this.bulkPurchaseRate)) {
          return;
        }
        productsToUpdate.map((prod) => {
          this.$root.$firebaseRefs.products.child(prod[".key"]).update({
            purchasingPrice: this.bulkPurchaseRate,
          });
        });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Data saved";
      } else {
        if (isNaN(this.bulkSellingRate)) {
          return;
        }
        productsToUpdate.map((prod) => {
          this.$root.$firebaseRefs.products.child(prod[".key"]).update({
            sellingPrice: this.bulkSellingRate,
          });
        });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Data saved";
      }
    },
    saveBulkHSN() {
      let productsToUpdate = this.productsByBrand;
      if (isNaN(this.bulkHSN)) {
        return;
      }
      productsToUpdate.map((prod) => {
        this.$root.$firebaseRefs.products.child(prod[".key"]).update({
          HSN_code: this.bulkHSN,
        });
      });
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveBulkSpecialChargePercentage() {
      let productsToUpdate = this.productsByBrand;
      if (isNaN(this.bulkSpecialChargePercentage)) {
        return;
      }
      productsToUpdate.map((prod) => {
        this.$root.$firebaseRefs.products.child(prod[".key"]).update({
          specialChargePercentage: this.bulkSpecialChargePercentage,
        });
      });
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveSellingRate(data) {
      if (isNaN(data.sellingPrice)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          sellingPrice: data.sellingPrice,
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    cancelRateSave() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    openRateSave() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    closeRateSave() {},
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Home/RateCard.vue